import React, { useRef, useEffect, useState } from "react";
import "../../styles/generals/homepage.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Slider1 from '../../images/slider1.jpg';
import Slider2 from '../../images/slider2.jpg';
import Slider3 from '../../images/slider3.jpg';
import Slider4 from '../../images/slider4.jpg';
import 'animate.css'

function HomePage(props) {
  // const containerRef = useRef(null);
  const navigate = useNavigate(); // Used for navigation after login

  // State for form inputs (common for Admin & Staff)
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
    companyUsername: "",
    role: "Employee",
  });

  const [showAdmin, setShowAdmin] = useState(true);
  const [showStaff, setShowStaff] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit form data
  const handleSubmit = async (e, role) => {
    e.preventDefault();
    props.handleLoading();
    loginData.role = role;
    try {
      const response = await axios.post(
        "https://api.dectwinservices.com/api/client-login",
        loginData
      );
      props.handleToast({
        toastMsg: "Login Successfully!!!",
        toastColor: "#4CAF50",
      });

      
      localStorage.setItem("exclserv_user", JSON.stringify(response.data));
      navigate("/client/dashboard");
    } catch (error) {
      if (error.status === 400) {
        props.handleToast({
          toastMsg: error.response.data.msg,
          toastColor: "#FF0000",
        });
      } else {
        props.handleToast({
          toastMsg: "Something went wrong! Please check data or internet.",
          toastColor: "#FF0000",
        });
      }
    }
    props.closeLoading();
  };

  const images = [
    Slider1,
    Slider2,
    Slider3,
    Slider4
];
const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);


  return (
        <section>
      <div className="slide-outer">

    <div className="slideshow-container">
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className="slideshow-image"
      />
    </div>

{/* <div className="col"> */}
  <div className="col-right">

    {showStaff && (
      <>
           <div className="form-wrapper animate__animated animate__zoomIn">
       <form
              className="form sign-up"
              onSubmit={(e) => handleSubmit(e, "Employee")}
            >
              <br />
            <span className="welcome-text">Welcome Staff</span>
            <br />
            <br />
              <div className="input-group">
                <i className="bx bxs-user"></i>
                <input
                  type="text"
                  name="username"
                  placeholder="Staff Username"
               style={{backgroundColor: 'white'}}
                  value={loginData.username}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <i className="bx bxs-business"></i>
                <input
                  type="text"
                  name="companyUsername"
                  placeholder="Company Username"
               style={{backgroundColor: 'white'}}
                  value={loginData.companyUsername}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <i className="bx bxs-lock-alt"></i>
                <input
                  type="password"
                  name="password"
                  placeholder="Your Password"
               style={{backgroundColor: 'white'}}
                  value={loginData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit">Sign In</button>
              {/* <p>
                <b>Forgot password?</b>
              </p> */}
              <p className="welcome-text">
                <span>Are you Admin? &nbsp;</span>
                <b onClick={() => {setShowStaff(false); setShowAdmin(true)}} className="pointer">
                  Sign in here
                </b>
              </p>
            </form>
          </div>      </>
    )}

    {showAdmin && (
                <div className="form-wrapper animate__animated animate__zoomIn">
            <form
              className="form sign-in"
              onSubmit={(e) => handleSubmit(e, "Admin")}
            >
              <br />
            <span className="welcome-text">Welcome Admin</span>
            <br />
            <br />
              <div className="input-group">
                <i className="bx bxs-user"></i>
                <input
                  type="text"
                  name="username"
                  placeholder="Admin Username"
               style={{backgroundColor: 'white'}}
                  value={loginData.username}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <i className="bx bxs-user"></i>
                <input
                  type="text"
                  name="companyUsername"
                  placeholder="Company Username"
               style={{backgroundColor: 'white'}}
                  value={loginData.companyUsername}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-group">
                <i className="bx bxs-lock-alt"></i>
                <input
                  type="password"
                  name="password"
                  placeholder="Your Password"
               style={{backgroundColor: 'white'}}
                  value={loginData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit">Sign in</button>
              {/* <p>
                <b>Forgot password?</b>
              </p> */}
              <p className="welcome-text bg-warning text-white">
                <span>Are You Staff? &nbsp;</span>
                <b onClick={() => {setShowStaff(true); setShowAdmin(false)}} className="pointer">
                  Sign in
                </b>
              </p>

              <p className="welcome-text bg-primary text-white">
                <span>Are You Engineer ? &nbsp;</span>
                <b onClick={() => navigate('/technician-login' )} className="pointer">
                  Sign in
                </b>
              </p>
            </form>
          </div>
    )}

</div>
</div>

      {/* </div> */}


      <div className="social-media-area">
        <p className="social-icon"><a style={{color: 'blue'}} href='https://www.facebook.com/share/g/14EkfQo5u1f/' target="_blank"><i className="fa-brands fa-facebook"></i></a></p>
         <p className="social-icon"><a style={{color: 'red'}} href='https://www.instagram.com/exclservsolutionsllp?igsh=ejBhYjZ4bG5ncW43' target="_blank"><i className="fa-brands fa-instagram"></i></a></p>
         <p className="social-icon"><a style={{color: 'blue'}} href='https://linkedin.com/company/exclserv-solutions-llp' target="_blank"><i className="fa-brands fa-linkedin"></i></a></p>
         <p className="social-icon"><a style={{color: 'green'}} href='https://wa.me/9599039841' target="_blank"><i className="fa-brands fa-whatsapp"></i></a></p>
         <p className="social-icon"><a style={{color: 'blue'}} href='https://exclserv.in/' target="_blank"><i className="fa-solid fa-globe"></i></a></p>
      </div>
    </section>

  );
}

export default HomePage;
